/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LiftBanPatientDialog.vue?vue&type=template&id=7dde3aac"
import script from "./LiftBanPatientDialog.vue?vue&type=script&lang=js"
export * from "./LiftBanPatientDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dde3aac')) {
      api.createRecord('7dde3aac', component.options)
    } else {
      api.reload('7dde3aac', component.options)
    }
    module.hot.accept("./LiftBanPatientDialog.vue?vue&type=template&id=7dde3aac", function () {
      api.rerender('7dde3aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/LiftBanPatientDialog.vue"
export default component.exports